<template>
  <div id="modal_popup_campaign_details" class="modal-popup">
    <div class="modal-popup-content">
      <a @click="showModalPopup('modal_popup_campaign_details', false)" class="close-button">
        <img src="@/assets/images/close-button.svg" />
      </a>
      <div class="d-inline-block" v-if="this.campaign">
        <div class="offer-details-wrapper">
          <div class="contact-details-wrapper">
            <label>
              start: {{ this.campaign.start }}
            </label>
            <label>
              end: {{ this.campaign.end }}
            </label>
          </div>
          <div class="contact-details-wrapper">
            <label>
              {{ this.campaign.channel }}
            </label>
            <label>
              {{ this.campaign.level }}
            </label>
          </div>       
           <div v-for="(entry) in this.campaign.content " :key="entry.language" class="container-fluid d-flex flex-column"  >
            <!-- <small class="text-break">{{ $t("cmsLang.language_" + entry.language.toUpperCase()) }}</small> -->
              <h5 >{{ entry.title }}</h5>
              <p v-if="entry.link" class="link"  v-html="entry.link"></p>
              <p class="description"  v-html="entry.body"></p>
            </div>

          <div class="details-wrapper" v-if="this.campaign.status === 'N' || this.campaign.status === 'I'">
            <div class="row d-flex flex-row ">
              <a @click="editGameDetails()" class="edit">
                <img src="@/assets/images/cms-mkt/edit.svg" />
              </a>
              <a @click="deleteGame()" class="delete">
                <img src="@/assets/images/cms-mkt/delete.svg" />
              </a>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "CampaignDetailsPopup",

  props: {
    user: Object,
    campaign: Object,
  },
  data() {
    return {
      // offer: null,
    };
  },
  methods: {
    editGameDetails() {
      this.$emit("edit", this.campaign);
    },
    deleteGame() {
      this.$emit("delete", this.campaign);
    },
  },
};
</script>
<style scoped src="@/assets/styles/mkt-cms.css"></style>
<style scoped>
.position {
  position: relative;
  left: 227px;
}

.contact-details-wrapper {
  justify-content: space-evenly;
}


label {
  width: 100%;
  border-radius: 9999px;
  border: 2px solid #fff;
  padding: 10px;
  margin: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  font-size: 14px;
  font-weight: lighter;
}

.offer-details-wrapper h5 {
  display: block;
}

.description {
  text-align: left;
  font-size: 16px;
}
.link {
  text-align: left;
  font-size: 12px;
  color:coral;
  text-decoration: underline;
}
</style>
